<template>
  <v-layout column>

    <h2>ROTINA DA CRIANÇA</h2>
    <h3 class="mb-2 text-secondary">CHILD ROUTINE</h3>

    <v-textarea
      outline
      v-model="resource.form.words_just_family_understands"
      label="PALAVRAS USADAS PELA CRIANÇA E QUE APENAS A FAMÍLIA ENTENDE/ WORDS USED BY THE CHILD THAT ONLY THE FAMILY ARE ABLE TO UNDERSTAND"
      placeholder="PALAVRAS USADAS PELA CRIANÇA E QUE APENAS A FAMÍLIA ENTENDE/ WORDS USED BY THE CHILD THAT ONLY THE FAMILY ARE ABLE TO UNDERSTAND"
    />

    <v-textarea
      outline
      v-model="resource.form.daily_routine"
      label="A ROTINA DIÁRIA DA CRIANÇA DA HORA QUE ACORDA ATÉ HORA DE DORMIR, INCLUINDO REFEIÇÕES/ THE CHILD´S DAILY ROUTINE SINCE THE MOMENT THAT HE/ SHE WAKES UP UNTIL THE BED TIME, INCLUDING THE MEALS"
      placeholder="A ROTINA DIÁRIA DA CRIANÇA DA HORA QUE ACORDA ATÉ HORA DE DORMIR, INCLUINDO REFEIÇÕES/ THE CHILD´S DAILY ROUTINE SINCE THE MOMENT THAT HE/ SHE WAKES UP UNTIL THE BED TIME, INCLUDING THE MEALS"
    />

    <v-textarea
      outline
      v-model="resource.form.school_day_routine"
      label="NOS DIAS ESCOLARES/ ON SCHOOL DAYS"
      placeholder="NOS DIAS ESCOLARES/ ON SCHOOL DAYS"
    />

    <v-textarea
      outline
      v-model="resource.form.mid_week_caretakers"
      label="QUANDO NÃO ESTÁ NA ESCOLA, COM QUEM ELE FICA E ONDE? WHEN THE CHILD IS NOT AT SCHOOL, WHO WILL SHE/HE BE WITH AND AT WHAT LOCATION?"
      placeholder="QUANDO NÃO ESTÁ NA ESCOLA, COM QUEM ELE FICA E ONDE? WHEN THE CHILD IS NOT AT SCHOOL, WHO WILL SHE/HE BE WITH AND AT WHAT LOCATION?"
    />

    <v-textarea
      outline
      v-model="resource.form.weekend_caretakers"
      label="NOS FINAIS DE SEMANA, COM QUEM ELE FICA? QUAIS ATIVIDADES SÃO FEITAS COM AMIGOS E/OU PARENTES? DURING WEEKENDS, WHO TAKES CARE OF THE CHILD? WHAT KIND OF ACTIVITIES DOES HE/SHE PARTICIPATE IN WITH PARENTS OR RELATIVES?"
      placeholder="NOS FINAIS DE SEMANA, COM QUEM ELE FICA? QUAIS ATIVIDADES SÃO FEITAS COM AMIGOS E/OU PARENTES? DURING WEEKENDS, WHO TAKES CARE OF THE CHILD? WHAT KIND OF ACTIVITIES DOES HE/SHE PARTICIPATE IN WITH PARENTS OR RELATIVES?"
    />

    <v-textarea
      outline
      v-model="resource.form.what_he_does_alone"
      label="O QUE SEU FILHO SABE FAZER SOZINHO?/ WHAT DOES THE CHILD DO BY HIM/HERSELF?"
      placeholder="O QUE SEU FILHO SABE FAZER SOZINHO?/ WHAT DOES THE CHILD DO BY HIM/HERSELF?"
    />

    <v-textarea
      outline
      v-model="resource.form.sleep_details"
      label="ELE DORME BEM? SOZINHO? DORME DURANTE O DIA? TEM OU JÁ TEVE PROBLEMAS PARA DORMIR? DOES HE/SHE SLEEP WELL? ALONE? DOES HE/SHE SLEEP DURING THE DAY? DID HE/SHE HAVE OR HAD ANY SLEEP RELATED PROBLEMS?"
      placeholder="ELE DORME BEM? SOZINHO? DORME DURANTE O DIA? TEM OU JÁ TEVE PROBLEMAS PARA DORMIR? DOES HE/SHE SLEEP WELL? ALONE? DOES HE/SHE SLEEP DURING THE DAY? DID HE/SHE HAVE OR HAD ANY SLEEP RELATED PROBLEMS?"
    />

    <v-textarea
      outline
      v-model="resource.form.recreation_details"
      label="DO QUE SEU FILHO GOSTA DE BRINCAR E QUAIS BRINQUEDOS OU OBJETOS ELE PREFERE? COM QUEM GOSTA DE BRINCAR? E POR QUANTO TEMPO ELE BRINCA POR DIA? WHAT DOES YOUR CHILD LIKE TO PLAY WITH AND WHAT KIND OF TOYS OR OBJECTS DOES HE/SHE PREFER? WITH WHOM DOES THE CHILD LIKE TO PLAY? HOW LONG DOES THE CHILD PLAY PER DAY?"
      placeholder="DO QUE SEU FILHO GOSTA DE BRINCAR E QUAIS BRINQUEDOS OU OBJETOS ELE PREFERE? COM QUEM GOSTA DE BRINCAR? E POR QUANTO TEMPO ELE BRINCA POR DIA? WHAT DOES YOUR CHILD LIKE TO PLAY WITH AND WHAT KIND OF TOYS OR OBJECTS DOES HE/SHE PREFER? WITH WHOM DOES THE CHILD LIKE TO PLAY? HOW LONG DOES THE CHILD PLAY PER DAY?"
    />

    <v-textarea
      outline
      v-model="resource.form.television_details"
      label="ASSISTE A TELEVISÃO? QUE TIPO DE PROGRAMA E QUAL SUA OPINIÃO A RESPEITO? DOES THE CHILD WATCH TV? WHAT KIND OF TV SHOW AND WHAT ARE YOUR FEELINGS ON THIS?"
      placeholder="ASSISTE A TELEVISÃO? QUE TIPO DE PROGRAMA E QUAL SUA OPINIÃO A RESPEITO? DOES THE CHILD WATCH TV? WHAT KIND OF TV SHOW AND WHAT ARE YOUR FEELINGS ON THIS?"
    />

  </v-layout>
</template>

<script>
/**
 * @group Form
 * Componente de form para dados da Rotina da criança
 */
export default {
  name: 'FormChildRoutine',

  data: () => ({
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    }
  }
}
</script>
